export enum NativeNamespaces {
  QR_CODE = 'QR_CODE',
  NOTIFICATION = 'NOTIFICATION',
  EMBEDDED_WEB_VIEW = 'EMBEDDED_WEB_VIEW',
  SYSTEM = 'SYSTEM'
}
